<template>
  <footer
    v-if="compact"
    :class="['flex items-center gap-3 text-xs whitespace-nowrap', transparent ? 'text-white' : 'text-muted-foreground']"
  >
    <span>© {{ year }} Earth PBC</span>
    <ul class="flex items-center gap-3 border-l border-border pl-3">
      <li v-for="link in links" :key="link.label">
        <a
          v-if="link.href"
          target="_blank"
          rel="noopener noreferrer"
          :href="link.href"
          class="hover:opacity-75"
        >{{ link.label }}</a>
        <Popover v-else-if="link.apps">
          <PopoverTrigger class="hover:opacity-75 cursor-pointer">{{ link.label }}</PopoverTrigger>
          <PopoverContent side="top" align="center" class="w-auto p-3">
            <div class="flex flex-col items-center gap-2">
              <a href="https://apps.apple.com/us/app/earth-pbc/id1590563602" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/img/app-store-badge.svg" alt="Download on the App Store" class="block" style="width:135px">
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.earthpbc.explorer" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/img/google-play-badge.png" alt="Get it on Google Play" class="block" style="width:154.6px;max-width:none;margin:-9.8px">
              </a>
            </div>
          </PopoverContent>
        </Popover>
        <a v-else href="#" @click.prevent="openSupport" class="hover:opacity-75">{{ link.label }}</a>
      </li>
    </ul>
  </footer>

  <footer v-else :class="['flex text-sm h-full', stacked ? 'flex-col xl:flex-row xl:items-center' : 'flex-col sm:flex-row sm:items-center', transparent ? 'bg-transparent text-white' : 'bg-background shadow-lg px-2']">
    <div :class="stacked ? 'xl:basis-1/3' : 'sm:basis-1/3'">
      <h4 class="whitespace-nowrap">© {{ year }}  Earth PBC. All Rights Reserved.</h4>
    </div>
    <div :class="stacked ? 'xl:basis-2/3' : 'sm:basis-2/3'">
      <div :class="['flex items-center', stacked ? 'xl:justify-end' : 'sm:justify-end']">
        <ul class="flex items-center justify-between w-full xl:justify-end xl:gap-4 xl:w-auto">
          <li v-for="link in links" :key="link.label">
            <a
              v-if="link.href"
              target="_blank"
              rel="noopener noreferrer"
              :href="link.href"
              class="hover:opacity-75"
            >{{ link.label }}</a>
            <Popover v-else-if="link.apps">
              <PopoverTrigger class="hover:opacity-75 cursor-pointer">{{ link.label }}</PopoverTrigger>
              <PopoverContent side="top" align="center" class="w-auto p-3">
                <div class="flex flex-col items-center gap-2">
                  <a href="https://apps.apple.com/us/app/earth-pbc/id1590563602" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/img/app-store-badge.svg" alt="Download on the App Store" class="block" style="width:135px">
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.earthpbc.explorer" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/img/google-play-badge.png" alt="Get it on Google Play" class="block" style="width:154.6px;max-width:none;margin:-9.8px">
                  </a>
                </div>
              </PopoverContent>
            </Popover>
            <a v-else href="#" @click.prevent="openSupport" class="hover:opacity-75">{{ link.label }}</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover'

export default {
  components: { Popover, PopoverTrigger, PopoverContent },
  props: {
    transparent: { type: Boolean, default: false },
    stacked: { type: Boolean, default: false },
    compact: { type: Boolean, default: false }
  },
  data () {
    return {
      links: [
        { label: 'Earth', href: 'https://earthpbc.com/' },
        { label: 'Privacy', href: 'https://earthpbc.com/privacy-policy' },
        { label: 'Terms', href: 'https://www.earthpbc.com/terms-of-service' },
        { label: 'About', href: 'https://www.earthpbc.com/about' },
        { label: 'Apps', apps: true },
        { label: 'Support', href: null }
      ]
    }
  },
  computed: {
    year () {
      return new Date().getFullYear()
    }
  },
  methods: {
    openSupport () {
      const zE = window.zE
      if (!zE) return
      if (typeof zE === 'function') {
        try { zE('messenger', 'open'); return } catch (e) {}
        try { zE('webWidget', 'open'); return } catch (e) {}
      }
      if (typeof zE.activate === 'function') zE.activate()
    }
  }
}
</script>
